// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pvWLi","label":"styles_label__1V9Xe"};